export default "__VITE_ASSET__BFuADWKg__"